import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Dark call-to-action card with a photo fading in from the right.
export default function CtaBand({ heading, text, to, label, image }) {
  return (
    <div className="relative isolate overflow-hidden rounded-3xl bg-[#1c1c1c]">
      {image && (
        <div className="absolute inset-y-0 right-0 w-full md:w-3/5">
          <img
            src={image}
            alt=""
            loading="lazy"
            className="h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-[#1c1c1c]/70 md:bg-[#1c1c1c]/10" />
          <div className="absolute inset-y-0 left-0 hidden w-3/4 bg-gradient-to-r from-[#1c1c1c] via-[#1c1c1c]/70 to-transparent md:block" />
        </div>
      )}

      <div className="relative px-6 py-12 sm:px-10 md:px-14 md:py-16">
        <h2 className="max-w-xl text-3xl font-semibold leading-tight text-white md:text-4xl">
          {heading}
        </h2>
        {text && (
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-white/75 md:text-base">
            {text}
          </p>
        )}
        <Link
          to={to}
          className="mt-6 inline-flex items-center gap-2 rounded-full bg-pink-500 px-7 py-3 text-[15px] font-semibold text-white shadow-[0_8px_20px_rgba(0,0,0,0.18)] transition hover:-translate-y-0.5 hover:bg-pink-600 active:scale-95"
        >
          {label}
          <ArrowRight size={18} aria-hidden="true" />
        </Link>
      </div>
    </div>
  );
}
